export default function getMapAllEntitiesWorker() {
  return new Worker(new URL('./mapAllEntities.worker.js', import.meta.url), {
    type: 'module',
  });
}
